var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "needsValidation page-container" }, [
    _c("div", { staticClass: "page-title" }, [_vm._v(" Payment Links ")]),
    _c("div", { staticClass: "filter-container" }, [
      _c("div", { staticClass: "custom-breadcrumbs" }, [
        _c("i", {
          staticClass: "el-icon-arrow-left icon-back",
          on: { click: _vm.onClickBackBtn },
        }),
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.status === _vm.statusObj["Payment_Needs_Validation"]
                ? "Creation"
                : "Submission"
            ) + " Details"
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "btn-container" },
        [
          _vm.status === _vm.statusObj["Payment_Needs_Validation"]
            ? _c(
                "el-button",
                {
                  staticClass: "mb-10",
                  attrs: {
                    type: "danger",
                    size: "small",
                    icon: "el-icon-delete",
                    disabled: _vm.submiting,
                  },
                  on: { click: _vm.onClickDeleteBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.delete")))]
              )
            : _vm._e(),
          _vm.status === _vm.statusObj["Payment_Approved"]
            ? _c(
                "el-button",
                {
                  staticClass: "mb-10",
                  attrs: {
                    type: "info",
                    size: "small",
                    icon: "el-icon-s-promotion",
                    disabled: _vm.submiting,
                  },
                  on: { click: _vm.onClickEmailBtn },
                },
                [_vm._v("Email")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "tableContainer",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _c("el-table-column", {
              attrs: { type: "selection", width: "55" },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.payment_method"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.payment_type))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.payment_channel"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.channel_code))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.reference"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.reference_batch_no)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("components.amount"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toThousandFilter")(scope.row.amount))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.customer_name"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.customer_name))]),
                    ]
                  },
                },
              ]),
            }),
            _vm.status !== _vm.statusObj["Payment_Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.validation"),
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.unvalidated_fields &&
                            scope.row.unvalidated_fields.length > 0
                              ? _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.unvalidated_fields.join(
                                                ","
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("br"),
                                      ]
                                    ),
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "tag-custom",
                                        attrs: { type: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.unvalidated_fields.join(
                                              ","
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "el-tag",
                                  {
                                    staticClass: "tag-custom",
                                    attrs: { type: "success" },
                                  },
                                  [_vm._v("Passed")]
                                ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2496788177
                  ),
                })
              : _vm._e(),
            _vm.status !== _vm.statusObj["Payment_Approved"]
              ? _c("el-table-column", {
                  attrs: { label: _vm.$t("components.email"), align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.email))])]
                        },
                      },
                    ],
                    null,
                    false,
                    2278809098
                  ),
                })
              : _vm._e(),
            _vm.status !== _vm.statusObj["Payment_Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.email_content"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.email_description)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2934050035
                  ),
                })
              : _vm._e(),
            _vm.status !== _vm.statusObj["Payment_Approved"]
              ? _c("el-table-column", {
                  attrs: { label: _vm.$t("data.remark"), align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    186672324
                  ),
                })
              : _vm._e(),
            _vm.status === _vm.statusObj["Payment_Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.status"),
                    align: "center",
                    "min-width": "150",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.transaction_status
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "modalBtn tag-custom",
                                    attrs: {
                                      type: _vm.getPOTransactionStatusType(
                                        scope.row.transaction_status
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getPOTransactionStatusMap(
                                            scope.row.transaction_status
                                          )
                                        )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    788229416
                  ),
                })
              : _vm._e(),
            _vm.status === _vm.statusObj["Payment_Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.link"),
                    align: "center",
                    "min-width": "300",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "link-container" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#3855F1",
                                      "text-decoration": "underline",
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.redirect_url))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    class: [
                                      "btn-copy",
                                      "copy-btn-" + scope.$index,
                                    ],
                                    attrs: {
                                      icon: "el-icon-copy-document",
                                      size: "mini",
                                      type: "primary",
                                      "data-clipboard-text":
                                        scope.row.redirect_url,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onClickCopyBtn(
                                          ".copy-btn-" + scope.$index,
                                          "Link"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.copy"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3102086383
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("components.operation"),
                align: "center",
                "min-width": "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.status === _vm.statusObj["Payment_Needs_Validation"]
                        ? _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.edit"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "icon-function ",
                                  "icon-class": "operation-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickEditBtn(scope.row)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.status === _vm.statusObj["Payment_Approved"]
                        ? _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.detail"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "icon-function",
                                  "icon-class": "operation-detail",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickDetailBtn(scope.row)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("SinglePaymentEditModal", {
          ref: "singleDisbursementEditModal",
          on: { getPaymentRefernceDetail: _vm.getPaymentRefernceDetail },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }